import { applyCpfCnpjMask } from '@/shared/utils/cnpj';
import { normalizeCpfCnpj } from '@/shared/utils/documentValidation';

export const formatCpfCnpj = (value: string): string => applyCpfCnpjMask(value);

export const unformatCpfCnpj = (value: string): string => normalizeCpfCnpj(value);
